"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENTS_BY_KEY = exports.DocumentType = exports.ProposalStatus = exports.SALES_GROUP = exports.salesGroups = exports.VOApplicationStageLabels = exports.VOStatusMap = exports.WORKFLOW_ACTIONS = exports.EVENTS = exports.OwnerSensitiveFieldsToFormat = exports.CreditAppSensitiveFieldsToFormat = exports.TaskRegardingValues = exports.FINANCING_TYPE = exports.EQUIPMENT_CONDITION = exports.CANADA_REGION_CODES = exports.US_REGION_CODES = exports.LEGAL_STRUCTURE = exports.LenderWaterfallPrescreenCriteriaResultType = exports.InventorySource = exports.PORTAL_TYPE = exports.WebhookType = exports.LenderProfileOcaAutoSubmissionEnum = exports.LenderProfleOcaBrandingEnum = exports.LenderProfleOcaTemplateEnum = exports.FinanceProgramRateType = void 0;
__exportStar(require("./generated"), exports);
var generated_1 = require("./generated");
var FinanceProgramRateType;
(function (FinanceProgramRateType) {
    FinanceProgramRateType["InterestRate"] = "INTEREST_RATE";
    FinanceProgramRateType["RateFactor"] = "RATE_FACTOR";
})(FinanceProgramRateType || (exports.FinanceProgramRateType = FinanceProgramRateType = {}));
var LenderProfleOcaTemplateEnum;
(function (LenderProfleOcaTemplateEnum) {
    LenderProfleOcaTemplateEnum["Lender"] = "LENDER";
    LenderProfleOcaTemplateEnum["Dealer"] = "DEALER";
})(LenderProfleOcaTemplateEnum || (exports.LenderProfleOcaTemplateEnum = LenderProfleOcaTemplateEnum = {}));
var LenderProfleOcaBrandingEnum;
(function (LenderProfleOcaBrandingEnum) {
    LenderProfleOcaBrandingEnum["Lender"] = "LENDER";
    LenderProfleOcaBrandingEnum["Dealer"] = "DEALER";
    LenderProfleOcaBrandingEnum["CoBranded"] = "CO_BRANDED";
})(LenderProfleOcaBrandingEnum || (exports.LenderProfleOcaBrandingEnum = LenderProfleOcaBrandingEnum = {}));
var LenderProfileOcaAutoSubmissionEnum;
(function (LenderProfileOcaAutoSubmissionEnum) {
    LenderProfileOcaAutoSubmissionEnum["Yes"] = "YES";
    LenderProfileOcaAutoSubmissionEnum["No"] = "NO";
})(LenderProfileOcaAutoSubmissionEnum || (exports.LenderProfileOcaAutoSubmissionEnum = LenderProfileOcaAutoSubmissionEnum = {}));
var WebhookType;
(function (WebhookType) {
    WebhookType["CREDIT_APPLICATION_RECEIVED"] = "CREDIT_APPLICATION_RECEIVED";
    WebhookType["CREDIT_APPLICATION_UPDATED"] = "CREDIT_APPLICATION_UPDATED";
    WebhookType["CREDIT_REPORT_CONSUMER_RECEIVED"] = "CREDIT_REPORT_CONSUMER_RECEIVED";
    WebhookType["CREDIT_REPORT_CONSUMER_UPDATED"] = "CREDIT_REPORT_CONSUMER_UPDATED";
})(WebhookType || (exports.WebhookType = WebhookType = {}));
var PORTAL_TYPE;
(function (PORTAL_TYPE) {
    PORTAL_TYPE[PORTAL_TYPE["DEALER"] = 1] = "DEALER";
    PORTAL_TYPE[PORTAL_TYPE["LENDER"] = 2] = "LENDER";
})(PORTAL_TYPE || (exports.PORTAL_TYPE = PORTAL_TYPE = {}));
var InventorySource;
(function (InventorySource) {
    InventorySource["Arcadium"] = "ARCADIUM";
})(InventorySource || (exports.InventorySource = InventorySource = {}));
var LenderWaterfallPrescreenCriteriaResultType;
(function (LenderWaterfallPrescreenCriteriaResultType) {
    LenderWaterfallPrescreenCriteriaResultType["PASS"] = "PASS";
    LenderWaterfallPrescreenCriteriaResultType["FAIL"] = "FAIL";
    LenderWaterfallPrescreenCriteriaResultType["PASS_WARNING"] = "PASS_WARNING";
    LenderWaterfallPrescreenCriteriaResultType["FAIL_WARNING"] = "FAIL_WARNING";
    LenderWaterfallPrescreenCriteriaResultType["ERROR"] = "ERROR";
})(LenderWaterfallPrescreenCriteriaResultType || (exports.LenderWaterfallPrescreenCriteriaResultType = LenderWaterfallPrescreenCriteriaResultType = {}));
var LEGAL_STRUCTURE;
(function (LEGAL_STRUCTURE) {
    LEGAL_STRUCTURE["CORPORATION"] = "803370001";
    LEGAL_STRUCTURE["LLC"] = "803370002";
    LEGAL_STRUCTURE["SOLE_PROPRIETORSHIP"] = "803370000";
    LEGAL_STRUCTURE["PARTNERSHIP"] = "803370003";
    LEGAL_STRUCTURE["MUNICIPALITY"] = "100000000";
    LEGAL_STRUCTURE["OWNER_OPERATOR"] = "100000001";
    LEGAL_STRUCTURE["INDIVIDUAL_OWNER_OPERATOR"] = "111111111";
    LEGAL_STRUCTURE["NON_PROFIT_CORPORATION"] = "100000002";
    LEGAL_STRUCTURE["PUBLICLY_TRADED_COMPANY"] = "100000003";
    LEGAL_STRUCTURE["UNKNOWN"] = "100000004";
})(LEGAL_STRUCTURE || (exports.LEGAL_STRUCTURE = LEGAL_STRUCTURE = {}));
var US_REGION_CODES;
(function (US_REGION_CODES) {
    US_REGION_CODES["Alabama"] = "AL";
    US_REGION_CODES["Alaska"] = "AK";
    US_REGION_CODES["AmericanSamoa"] = "AS";
    US_REGION_CODES["Arizona"] = "AZ";
    US_REGION_CODES["Arkansas"] = "AR";
    US_REGION_CODES["California"] = "CA";
    US_REGION_CODES["Colorado"] = "CO";
    US_REGION_CODES["Connecticut"] = "CT";
    US_REGION_CODES["Delaware"] = "DE";
    US_REGION_CODES["DistrictOfColumbia"] = "DC";
    US_REGION_CODES["FederatedStatesOfMicronesia"] = "FM";
    US_REGION_CODES["Florida"] = "FL";
    US_REGION_CODES["Georgia"] = "GA";
    US_REGION_CODES["Guam"] = "GU";
    US_REGION_CODES["Hawaii"] = "HI";
    US_REGION_CODES["Idaho"] = "ID";
    US_REGION_CODES["Illinois"] = "IL";
    US_REGION_CODES["Indiana"] = "IN";
    US_REGION_CODES["Iowa"] = "IA";
    US_REGION_CODES["Kansas"] = "KS";
    US_REGION_CODES["Kentucky"] = "KY";
    US_REGION_CODES["Louisiana"] = "LA";
    US_REGION_CODES["Maine"] = "ME";
    US_REGION_CODES["MarshallIslands"] = "MH";
    US_REGION_CODES["Maryland"] = "MD";
    US_REGION_CODES["Massachusetts"] = "MA";
    US_REGION_CODES["Michigan"] = "MI";
    US_REGION_CODES["Minnesota"] = "MN";
    US_REGION_CODES["Mississippi"] = "MS";
    US_REGION_CODES["Missouri"] = "MO";
    US_REGION_CODES["Montana"] = "MT";
    US_REGION_CODES["Nebraska"] = "NE";
    US_REGION_CODES["Nevada"] = "NV";
    US_REGION_CODES["NewHampshire"] = "NH";
    US_REGION_CODES["NewJersey"] = "NJ";
    US_REGION_CODES["NewMexico"] = "NM";
    US_REGION_CODES["NewYork"] = "NY";
    US_REGION_CODES["NorthCarolina"] = "NC";
    US_REGION_CODES["NorthDakota"] = "ND";
    US_REGION_CODES["NorthernMarianaIslands"] = "MP";
    US_REGION_CODES["Ohio"] = "OH";
    US_REGION_CODES["Oklahoma"] = "OK";
    US_REGION_CODES["Oregon"] = "OR";
    US_REGION_CODES["Palau"] = "PW";
    US_REGION_CODES["Pennsylvania"] = "PA";
    US_REGION_CODES["PuertoRico"] = "PR";
    US_REGION_CODES["RhodeIsland"] = "RI";
    US_REGION_CODES["SouthCarolina"] = "SC";
    US_REGION_CODES["SouthDakota"] = "SD";
    US_REGION_CODES["Tennessee"] = "TN";
    US_REGION_CODES["Texas"] = "TX";
    US_REGION_CODES["Utah"] = "UT";
    US_REGION_CODES["Vermont"] = "VT";
    US_REGION_CODES["VirginIslands"] = "VI";
    US_REGION_CODES["Virginia"] = "VA";
    US_REGION_CODES["Washington"] = "WA";
    US_REGION_CODES["WestVirginia"] = "WV";
    US_REGION_CODES["Wisconsin"] = "WI";
    US_REGION_CODES["Wyoming"] = "WY";
})(US_REGION_CODES || (exports.US_REGION_CODES = US_REGION_CODES = {}));
var CANADA_REGION_CODES;
(function (CANADA_REGION_CODES) {
    CANADA_REGION_CODES["Alberta"] = "AB";
    CANADA_REGION_CODES["BritishColumbia"] = "BC";
    CANADA_REGION_CODES["Manitoba"] = "MB";
    CANADA_REGION_CODES["NewBrunswick"] = "NB";
    CANADA_REGION_CODES["NewfoundlandAndLabrador"] = "NL";
    CANADA_REGION_CODES["NovaScotia"] = "NS";
    CANADA_REGION_CODES["NorthwestTerritories"] = "NT";
    CANADA_REGION_CODES["Nunavut"] = "NU";
    CANADA_REGION_CODES["Ontario"] = "ON";
    CANADA_REGION_CODES["PrinceEdwardIsland"] = "PE";
    CANADA_REGION_CODES["Quebec"] = "QC";
    CANADA_REGION_CODES["Saskatchewan"] = "SK";
    CANADA_REGION_CODES["Yukon"] = "YT";
})(CANADA_REGION_CODES || (exports.CANADA_REGION_CODES = CANADA_REGION_CODES = {}));
var EQUIPMENT_CONDITION;
(function (EQUIPMENT_CONDITION) {
    EQUIPMENT_CONDITION["NEW"] = "NEW";
    EQUIPMENT_CONDITION["USED"] = "USED";
    EQUIPMENT_CONDITION["REFURBISHED"] = "REFURBISHED";
})(EQUIPMENT_CONDITION || (exports.EQUIPMENT_CONDITION = EQUIPMENT_CONDITION = {}));
var FINANCING_TYPE;
(function (FINANCING_TYPE) {
    FINANCING_TYPE["equipmentFinancing"] = "Finance";
    FINANCING_TYPE["creditLine"] = "Credit Line";
    FINANCING_TYPE["lease"] = "Lease";
    FINANCING_TYPE["catCard"] = "CAT Card";
    FINANCING_TYPE["oemCard"] = "OEM Card";
})(FINANCING_TYPE || (exports.FINANCING_TYPE = FINANCING_TYPE = {}));
var TaskRegardingValues;
(function (TaskRegardingValues) {
    TaskRegardingValues["signatures"] = "Signatures";
    TaskRegardingValues["newSignorAndGuarantorSignature"] = "New Signor & Guarantor - Signature";
    TaskRegardingValues["catFiAddedndum"] = "CAT FI Addendum";
    TaskRegardingValues["dlUpload"] = "Driver's license upload";
    TaskRegardingValues["insuranceQuote"] = "Provide Insurance Quote";
    TaskRegardingValues["insuranceVerification"] = "Insurance Verification";
    TaskRegardingValues["recertificationSignatures"] = "Recertification - Signatures";
    TaskRegardingValues["tradeReference"] = "Trade Reference";
})(TaskRegardingValues || (exports.TaskRegardingValues = TaskRegardingValues = {}));
var CreditAppSensitiveFieldsToFormat;
(function (CreditAppSensitiveFieldsToFormat) {
    CreditAppSensitiveFieldsToFormat["DateOfBirth"] = "dateOfBirth";
    CreditAppSensitiveFieldsToFormat["Ssn"] = "ssn";
    CreditAppSensitiveFieldsToFormat["TaxId"] = "taxId";
    CreditAppSensitiveFieldsToFormat["DriversLicenseNum"] = "driversLicenseNum";
})(CreditAppSensitiveFieldsToFormat || (exports.CreditAppSensitiveFieldsToFormat = CreditAppSensitiveFieldsToFormat = {}));
var OwnerSensitiveFieldsToFormat;
(function (OwnerSensitiveFieldsToFormat) {
    OwnerSensitiveFieldsToFormat["DateOfBirth"] = "dateOfBirth";
    OwnerSensitiveFieldsToFormat["Ssn"] = "ssn";
    OwnerSensitiveFieldsToFormat["DriversLicenseNum"] = "driversLicenseNum";
})(OwnerSensitiveFieldsToFormat || (exports.OwnerSensitiveFieldsToFormat = OwnerSensitiveFieldsToFormat = {}));
exports.EVENTS = {
    VENDOR_OPPORTUNITY_CREATED: "VENDOR_OPPORTUNITY_CREATED",
    VENDOR_OPPORTUNITY_UPDATED: "VENDOR_OPPORTUNITY_UPDATED",
    CREDIT_APPLICATION_CREATED: "CREDIT_APPLICATION_CREATED",
    CREDIT_APPLICATION_UPDATED: "CREDIT_APPLICATION_UPDATED",
    CREDIT_SUBMISSION_CREATED: "CREDIT_SUBMISSION_CREATED",
    CREDIT_SUBMISSION_UPDATED: "CREDIT_SUBMISSION_UPDATED",
};
var WORKFLOW_ACTIONS;
(function (WORKFLOW_ACTIONS) {
    WORKFLOW_ACTIONS["create_task"] = "Create Task";
})(WORKFLOW_ACTIONS || (exports.WORKFLOW_ACTIONS = WORKFLOW_ACTIONS = {}));
exports.VOStatusMap = new Map([
    [100, "prospect"],
    [150, "pre qualified"],
    [200, "approved"],
    [300, "funded"],
    [400, "cancelled"],
    [410, "dealer cancelled"],
    [420, "customer cancelled"],
    [500, "declined"],
]);
exports.VOApplicationStageLabels = (_a = {},
    _a[generated_1.ApplicationStage.Approved] = "Approved",
    _a[generated_1.ApplicationStage.Cancelled] = "Cancelled",
    _a[generated_1.ApplicationStage.CustomerCancelled] = "Customer Cancelled",
    _a[generated_1.ApplicationStage.DealerCancelled] = "Dealer Cancelled",
    _a[generated_1.ApplicationStage.Declined] = "Declined",
    _a[generated_1.ApplicationStage.Funded] = "Funded",
    _a[generated_1.ApplicationStage.PreQualified] = "Pre-Qualified",
    _a[generated_1.ApplicationStage.Prospect] = "Prospect",
    _a);
exports.salesGroups = {
    sales_rep: "Sales Rep",
    sales_mgr: "Sales Manager",
    finance_manager: "Finance Manager",
};
var SALES_GROUP;
(function (SALES_GROUP) {
    SALES_GROUP["sales_rep"] = "Sales Rep";
    SALES_GROUP["sales_mgr"] = "Sales Manager";
    SALES_GROUP["finance_manager"] = "Finance Manager";
})(SALES_GROUP || (exports.SALES_GROUP = SALES_GROUP = {}));
var ProposalStatus;
(function (ProposalStatus) {
    ProposalStatus["Accepted"] = "Accepted";
    ProposalStatus["Created"] = "Created";
    ProposalStatus["Draft"] = "Draft";
    ProposalStatus["ProposalSent"] = "Proposal Sent";
    ProposalStatus["ViewedByCustomer"] = "Viewed by customer";
    ProposalStatus["QuoteSent"] = "Quote Sent";
})(ProposalStatus || (exports.ProposalStatus = ProposalStatus = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["quote"] = "Quote";
    DocumentType["invoice"] = "Invoice";
    DocumentType["buyers_order"] = "Buyers order";
    DocumentType["decision_letter"] = "Decision letter";
    DocumentType["insurance_certificate"] = "Insurance certificate";
    DocumentType["driver_license"] = "Driver license";
    DocumentType["bank_statements"] = "Bank statements";
    DocumentType["tax_returns"] = "Tax returns";
    DocumentType["equipment_specs"] = "Equipment specs";
    DocumentType["sales_tax_exemption"] = "Sales Tax exemption";
    DocumentType["credit_app_scan"] = "Credit App scan";
    DocumentType["other"] = "Other";
    DocumentType["credit_report"] = "Credit Report";
    DocumentType["compliance"] = "Compliance";
    DocumentType["addendum"] = "Addendum";
    DocumentType["financial"] = "Financial";
})(DocumentType || (exports.DocumentType = DocumentType = {}));
exports.DOCUMENTS_BY_KEY = {
    quote: { key: "quote", value: "quote", text: "Quote" },
    invoice: { key: "invoice", value: "invoice", text: "Invoice" },
    buyers_order: {
        key: "buyers_order",
        value: "buyers order",
        text: "Buyer's Order",
    },
    decision_letter: {
        key: "decision_letter",
        value: "decision letter",
        text: "Decision Letter",
    },
    insurance_certificate: {
        key: "insurance_certificate",
        value: "insurance certificate",
        text: "Insurance Certificate",
    },
    driver_license: {
        key: "driver_license",
        value: "driver license",
        text: "Driver License",
    },
    bank_statements: {
        key: "bank_statements",
        value: "bank statements",
        text: "Bank Statements",
    },
    tax_returns: {
        key: "tax_returns",
        value: "tax returns",
        text: "Tax Returns",
    },
    equipment_specs: {
        key: "equipment_specs",
        value: "equipment specs",
        text: "Equipment Specs",
    },
    sales_tax_exemption: {
        key: "sales_tax_exemption",
        value: "sales tax exemption",
        text: "Sales Tax Exemption",
    },
    credit_app_scan: {
        key: "credit_app_scan",
        value: "credit app scan",
        text: "Credit App Scan",
    },
    other: { key: "other", value: "other", text: "Other" },
    credit_report: {
        key: "credit_report",
        value: "Credit Report",
        text: "Credit Report",
    },
    compliance: {
        key: "compliance",
        value: "Compliance",
        text: "Compliance",
    },
    addendum: { key: "addendum", value: "Addendum", text: "Addendum" },
    financial: { key: "financial", value: "Financial", text: "Financial Doc" },
};
